import i18n from 'modules/core/lib/i18n'

export const categoryLabel = (category: string) => {
  switch (category) {
    case 'custom':
    case 'training':
      return i18n.t('processes.materialize_process.categories.custom')
    case 'onboarding':
      return i18n.t('processes.materialize_process.categories.onboarding')
    case 'offboarding':
      return i18n.t('processes.materialize_process.categories.offboarding')
    default:
      return category
  }
}
